<template>
    <div>
        <div style="margin-top: 10px;">
            <p><h5>{{ $t('objects.details.basedata') }}</h5></p>
        </div>
        <div class="table-responsive" style="margin-top: 10px;" v-if="rmsobject.created_at">
            <table class="table">
                <tbody>

                <tr>
                    <td>{{ $t('objects.details.images') }}</td>
                    <td>
                        <CoolLightBox
                            :items="galleryItems"
                            :index="index"
                            @close="index = null">
                        </CoolLightBox>
                        <div class="images-wrapper">
                            <div
                                class="image"
                                v-for="(image, imageIndex) in galleryItems"
                                :key="imageIndex"
                                @click="index = imageIndex"
                                :style="{ backgroundImage: 'url(' + image.thumb + ')' }"
                            ></div>
                        </div>
                    </td>
                    <!--<td><img :src="rmsobject.image" /></td>-->
                </tr>
                <tr>
                    <td>{{ $t('objects.details.number') }}</td>
                    <td>{{rmsobject.number}}</td>
                </tr>
                <tr>
                    <td>{{ $t('objects.details.inventory-number') }}</td>
                    <td>{{rmsobject.inventory_number}}</td>
                </tr>
                <tr>
                    <td>{{ $t('objects.details.name') }}</td>
                    <td>{{rmsobject.name}}</td>
                </tr>
                <tr>
                    <td>{{ $t('objects.details.description') }}</td>
                    <td>{{rmsobject.desc}}</td>
                </tr>
                <tr v-if="rmsobject.category">
                    <td>{{ $t('objects.details.category') }}</td>
                    <td>{{rmsobject.category.name}}</td>
                </tr>
                <tr>
                    <td>{{ $t('objects.details.condition') }}</td>
                    <td>{{rmsobject.condition}}</td>
                </tr>
                <tr>
                    <td>{{ $t('objects.details.tags') }}</td>
                    <td>
                        <span v-for="(item, index) in rmsobject.attachedTags">
                            <span>{{item.text}}</span><span v-if="index+1 < rmsobject.attachedTags.length">, </span>
                        </span>
                    </td>
                </tr>
                <tr v-if="rmsobject.location">
                    <td>{{ $t('objects.details.location') }}</td>
                    <td>{{rmsobject.location.name}}</td>
                </tr>
                <tr>
                    <td>{{ $t('objects.details.availability') }}</td>
                    <td>{{rmsobject.statusName}}</td>
                </tr>
                <tr>
                    <td>{{ $t('objects.details.available-for-rental-requests') }}</td>
                    <td>{{ $t('general.bool_' + rmsobject.requestable)}}</td>
                </tr>
                <tr>
                    <td>{{ $t('objects.details.notes') }}</td>
                    <td><span v-html="rmsobject.note"></span></td>
                </tr>
                <tr>
                    <td>{{ $t('objects.details.created') }}</td>
                    <td>{{formattedCreatedAt}}</td>
                </tr>
                <tr>
                    <td>{{ $t('objects.details.updated') }}</td>
                    <td>{{formattedUpdatedAt}}</td>
                </tr>
                </tbody>
            <div style="margin-top: 10px;">
                <p><h5>{{ $t('objects.details.additional-fields') }}</h5></p>
            </div>

                <tbody>
                    <tr>
                        <td><b>{{ $t('objects.details.field-set-definition') }}</b></td>
                        <td v-if="rmsobject.field_set_definition"><b>{{rmsobject.field_set_definition.name}}</b></td>
                    </tr>

                    <!-- Hier alle zusätzlichen Formularfelder anzeigen -->
                    <tr v-for="(fieldType, index) in rmsobject.field_type" v-if="rmsobject.form_data">
                        <td>{{ $t('cstrings.colfields.' + fieldType.configuration.label)}}</td>
                        <td>{{rmsobject.form_data[fieldType.configuration.model]}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
    export default {
        inheritAttrs: true,
        name: "rms-objects-detail-tab",
        props: ['user', 'rmsobject'],
        components: {
            CoolLightBox,
        },
        data: function () {
            return {
                index: null
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init: function () {
            }
        },
        computed:{
            formattedCreatedAt() {
                if(this.rmsobject.created_at){
                    return moment(this.rmsobject.created_at).format(AshnetApp.dateTimeFormat);
                }
                return '';
            },
            formattedUpdatedAt() {
                if(this.rmsobject.updated_at){
                    return moment(this.rmsobject.updated_at).format(AshnetApp.dateTimeFormat);
                }
                return '';
            },

            /**
             * Galerie für Equipment-Detail zurückgeben
             * See: https://vue-cool-lightbox.lucaspulliese.com/
             * @returns {[]} Array of images für component
             */
            galleryItems:function(){
                let tmpGalleryItems=[];
                for (const itemsKey in this.rmsobject.images) {
                    tmpGalleryItems.push(
                        {
                            title: this.rmsobject.images[itemsKey].file_name,
                            description: this.rmsobject.images[itemsKey].name,
                            src: this.rmsobject.images[itemsKey].original_url,
                            thumb: this.rmsobject.images[itemsKey].preview_url,
                        }
                    )
                }
                return tmpGalleryItems;
            }
        }
    }
</script>

<style scoped>
 .images-wrapper{
     display: flex;
 }
 .image{
     cursor: pointer;
     background-repeat: no-repeat;
     background-size: contain;
     margin-right: 20px;
     min-height: 150px;
     min-width: 150px;
     max-width:250px;
     max-height:250px;
 }
</style>
